import { RouteObject } from "react-router-dom";
import ErrorPage from "./ErrorPage";
import OAuth2ErrorPage from "./oauth2-error-page";
import OAuth2SuccessPage from "./oauth2-success-page";
import PremiumPage from "./premium-page";
import VotarEmpresaInspiradoraExternoPage from "./votar-empresa-inspiradora-externo-page";

const publicRoutes: RouteObject[] = [
  {
    path: "/votarEmpresaInspiradora/:licenciadaId/:empresaId/:questionarioId",
    element: <VotarEmpresaInspiradoraExternoPage />,
    errorElement: <ErrorPage />
  },
  {
    path: "/premium",
    element: <PremiumPage />,
    errorElement: <ErrorPage />
  },
  // OAuth2 callback routes (run in popup window)
  {
    path: "/oauth2/success",
    element: <OAuth2SuccessPage />,
    errorElement: <ErrorPage />
  },
  {
    path: "/oauth2/error",
    element: <OAuth2ErrorPage />,
    errorElement: <ErrorPage />
  }
];

export default publicRoutes;
